import { render, staticRenderFns } from "./AddServiceForm.vue?vue&type=template&id=b45f7b3a&"
import script from "./AddServiceForm.vue?vue&type=script&lang=ts&"
export * from "./AddServiceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports